import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./customizeSpotTheme.css";
import { fetchThemeData } from "../../themeSlice";
import { selectAdminToken } from "../../sessionSlice";
import YogaPosesEditor from "./YogaPosesEditor";

const CustomizeSpotTheme = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const { currentTheme, data } = useSelector((s) => s.theme);

  useEffect(() => {
    if (currentTheme) dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch, currentTheme]);

  const gameName = data?.themeName || data?.themename || "Yoga Quest";

  return (
    <YogaPosesEditor
      data={data}
      currentTheme={currentTheme}
      adminToken={adminToken}
      gameName={gameName}
      onBack={() => navigate("/admin/rules")}
    />
  );
};

export default CustomizeSpotTheme;
